import { Link } from 'react-router';
import { noop } from 'libs';

interface UpgradeProps {
  buttonText?: string;
  className?: string | null;
  onClick?: () => void;
}

const Upgrade = ({ buttonText = 'Upgrade', className = null, onClick = noop }: UpgradeProps) => (
  <Link to="/settings/upgrade" className={className as string | undefined} onClick={onClick}>
    {buttonText}
  </Link>
);

export default Upgrade;
